import type { MapLegendTarget } from './types';

export const MAP_LEGEND_ITEMS: {
  id: MapLegendTarget;
  label: string;
}[] = [
  { id: 'deliveryman', label: 'Entregador' },
  { id: 'place', label: 'Loja' },
  { id: 'delivery', label: 'Entrega' },
  { id: 'start', label: 'Início do trajeto' },
  { id: 'end', label: 'Fim do trajeto' },
];

export const MAP_LINE_LEGEND_LABEL = 'Rota da entrega';
export const MAP_ACTION_LEGEND_LABEL = 'Ação do entregador';
export const MAP_MANAGER_ACTION_LEGEND_LABEL = 'Ação pelo admin';
